import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

import Base02Container from 'src/components/Base02Container';
import ReverseGradientIconTextButton from 'src/components/ReverseGradientIconTextButton';

export const TopHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginBottom: '3.8rem',
});

export const ScrollContainer = styled('div')(({ theme }) => ({
  '*::-webkit-scrollbar': {
    width: '0.1rem',
    height: '0.1rem',
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.base03,
  },
  '*::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
}));

export const BodyContainer = styled('div')({
  height: '51rem',

  overflow: 'auto',

  margin: '0 -4rem',
  padding: '0 4rem',
});

export const PathwayContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',

  rowGap: '1.2rem',

  marginBottom: '3rem',
});

export const TopStakingAmountContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,

  marginBottom: '1.2rem',

  padding: '0 1.2rem',
}));

export const DYDXTopIconContainer = styled('div')({
  width: '2.4rem',
  height: '2.4rem',

  marginRight: '0.8rem',

  '& > svg': {
    width: '2.4rem',
    height: '2.4rem',
  },
});

export const RewardContainer = styled('div')({});

export const StakingStatusContainer = styled(Base02Container)(({ theme }) => ({
  width: '100%',

  color: theme.colors.base01,

  marginBottom: '1.6rem',
}));

export const StakingStatusBodyContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',

  rowGap: '1.4rem',
});

export const StakingStatusBodyTextContainer = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const SwapButtonContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '4rem',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  '&.MuiCircularProgress-root': {
    color: theme.colors.base01,
  },
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));

export const AmountContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
});

export const DYDXTopLeftContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base02,
}));

export const DYDXTopLeftAmountContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const RewardTokenContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',
});

export const RewardTokenIconContainer = styled('div')({
  width: '2rem',
  height: '2rem',

  '& > svg': {
    width: '2rem',
    height: '2rem',
  },
});

export const StyledReverseGradientIconTextButton = styled(ReverseGradientIconTextButton)({
  width: '100%',

  marginTop: '2rem',
});
